// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      importTypesSearch: [
        "Operations Notifications",
        "Work Requests",
        "Engineering",
        "Risk Assessment"
      ]
    };
  }
};
